import {Password, User} from './Forgot';
const expo = {Password, User};
export default expo;